import { render, staticRenderFns } from "./BusinessQuestion.vue?vue&type=template&id=4bf0002d&scoped=true"
import script from "./BusinessQuestion.vue?vue&type=script&lang=js"
export * from "./BusinessQuestion.vue?vue&type=script&lang=js"
import style0 from "./BusinessQuestion.vue?vue&type=style&index=0&id=4bf0002d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf0002d",
  null
  
)

export default component.exports